import {AxiosError} from 'axios';
import {GET_NOTIFICATION_VIEW_DETAILS_QUERY_KEY} from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import {GET_NOTIFICATION_VIEW_DETAILS_URL} from '../../constants/apiUrls';
import {useCustomQuery} from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
interface GroupRecipientObject {
  examLevel: string;
  recipientType: string;
  school: string;
  candidateType: string;
}

export interface IndividualRecipientObject {
  emailMobile: string;
  indexNo: string;
  name: string;
  nricFinPassport: string;
  userUuid: string;
}

export interface NotificationViewDetailsResponse {
  groupRecipient: GroupRecipientObject;
  individualRecipients?: IndividualRecipientObject[];
  candidateRecipient: boolean;
  individualRecipient: boolean;
  status: string;
  title: string;
  message: string;
  sentBy: string;
  sentDateTime: string;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (res: NotificationViewDetailsResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  uuid: string;
  notificationType: string;
}

export const useGetNotificationViewDetails = ({
                                                onSuccess,
                                                onError,
                                                uuid,
                                                notificationType,
                                              }: Input) => {
  const getNotificationViewDetails = async () => {
    const res = await axiosClient.get<NotificationViewDetailsResponse>(
        GET_NOTIFICATION_VIEW_DETAILS_URL(uuid, notificationType)
    );
    return res.data;
  };

  return useCustomQuery(GET_NOTIFICATION_VIEW_DETAILS_QUERY_KEY, getNotificationViewDetails, {
    onSuccess,
    onError,
  });
};
